import {useTypedSelector} from './reduxUtil';

export function useLoggedIn(): boolean {
  return useTypedSelector((state) => Boolean(state.auth.token));
}
